var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":_vm.width,"value":_vm.visible,"persistent":true,"overlay-opacity":"0.8"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }